/*
 * Address Card Component - unified for both shipping and billing
 */
import React from 'react'
import PropTypes from 'prop-types'
import {RadioCard} from '/overrides/app/components/radio-card'
import ActionCard from '/overrides/app/components/action-card'
import AddressDisplay from '/overrides/app/components/address-display'
import {msgf, useTranslationHelpers} from '@epmc-mach/accelarator/overrides/app/hooks'

const AddressCard = ({
    address,
    index,
    onEdit,
    onRemove,
    editBtnRef,
    isEditingAddress,
    editingAddressId, // For billing (address being edited)
    selectedAddressId, // For shipping (legacy prop)
    EditFormComponent,
    type = 'shipping' // 'shipping' or 'billing'
}) => {
    const {tShipping} = useTranslationHelpers()

    // Determine which address ID to use for comparison
    const currentEditingId =
        type === 'billing' ? editingAddressId : editingAddressId || selectedAddressId

    // Get appropriate translation IDs based on type
    const getEditLabel = () => {
        if (type === 'billing') {
            return msgf(tShipping.a11yEdit, [address.address1])
        }
        return msgf(tShipping.a11yEdit, [address.address1])
    }

    const getRemoveLabel = () => {
        if (type === 'billing') {
            return msgf(tShipping.a11yRemove, [address.address1])
        }
        return msgf(tShipping.a11yRemove, [address.address1])
    }

    const actionCardProps = {
        padding: 0,
        border: 'none',
        onEdit: () => onEdit(address),
        onRemove: () => onRemove(address.addressId),
        editBtnLabel: getEditLabel(),
        removeBtnLabel: getRemoveLabel()
    }

    // Add optional props if they exist
    if (editBtnRef) {
        actionCardProps.editBtnRef = editBtnRef
    }

    if (type === 'shipping' && typeof index === 'number') {
        actionCardProps['data-testid'] = `sf-checkout-shipping-address-${index}`
    }

    return (
        <React.Fragment key={address.addressId}>
            <RadioCard value={address.addressId}>
                <ActionCard {...actionCardProps}>
                    <AddressDisplay address={address} />
                </ActionCard>
            </RadioCard>
            {isEditingAddress &&
                currentEditingId &&
                address.addressId === currentEditingId &&
                EditFormComponent}
        </React.Fragment>
    )
}

AddressCard.propTypes = {
    address: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    editBtnRef: PropTypes.object,
    isEditingAddress: PropTypes.bool.isRequired,
    editingAddressId: PropTypes.string, // For billing
    selectedAddressId: PropTypes.string, // For shipping (legacy)
    EditFormComponent: PropTypes.node,
    type: PropTypes.oneOf(['shipping', 'billing'])
}

export default AddressCard
